module.exports = __webpack_public_path__ + "img/w1.d18ae246.webp";